import { INIT, SUCCESS, LOADING, ERROR } from "../../../utils/constants";
import {
  GET_AZURE_MONITOR_STORAGE_ACCOUNT,
  GET_AZURE_MONITOR_STORAGE_ACCOUNT_SUCCESS,
  GET_AZURE_MONITOR_STORAGE_ACCOUNT_ERROR,
  // GET_AZURE_MONITOR_APPLICATION_RESOURCE_NAMES,
  // GET_AZURE_MONITOR_APPLICATION_RESOURCE_NAMES_SUCCESS,
  // GET_AZURE_MONITOR_APPLICATION_RESOURCE_NAMES_ERROR,
} from "./constant";

const initialState = {
  phase: INIT,
  azureMonitorStorageAccountList: null,
  error: null,
};

// const initialStateApplicationResourceNames = {
//   phase2: INIT,
//   azureMonitorApplicationResourceNamesList: null,
//   error: null,
// };

/**
 * User Reducer
 * @param {Object} state
 * @param {Object} action
 */

export function AzureMonitorStorageAccountStore(state = initialState, action) {
  switch (action.type) {
    case GET_AZURE_MONITOR_STORAGE_ACCOUNT:
      return {
        ...state,
        phase: LOADING,
      };
    case GET_AZURE_MONITOR_STORAGE_ACCOUNT_SUCCESS:
      return {
        ...state,
        phase: SUCCESS,
        azureMonitorStorageAccountList: action.data,
        error: null,
      };
    case GET_AZURE_MONITOR_STORAGE_ACCOUNT_ERROR:
      return { ...state, phase: ERROR, error: action.error };

    default:
      return state;
  }
}

// export function AzureMonitorApplicationResourceNamesStore(
//   state = initialStateApplicationResourceNames,
//   action
// ) {
//   switch (action.type) {
//     case GET_AZURE_MONITOR_APPLICATION_RESOURCE_NAMES:
//       return {
//         ...state,
//         phase2: LOADING,
//       };
//     case GET_AZURE_MONITOR_APPLICATION_RESOURCE_NAMES_SUCCESS:
//       return {
//         ...state,
//         phase2: SUCCESS,
//         azureMonitorApplicationResourceNamesList: action.data,
//         error: null,
//       };
//     case GET_AZURE_MONITOR_APPLICATION_RESOURCE_NAMES_ERROR:
//       return { ...state, phase2: ERROR, error: action.error };

//     default:
//       return state;
//   }
// }
